import api from '.'

export const queries = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/queries`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/queries`, null, success, fail)
  },
  update (queryId, data, success, fail) {
    api.authenticatedRequest('PUT', `/queries/${queryId}`, data, success, fail)
  },
  delete (queryId, success, fail) {
    api.authenticatedRequest('DELETE', `/queries/${queryId}`, null, success, fail)
  },
  getComments (queryId, page, pageSize, success, fail) {
    const query = `?page=${page || 1}&page_size=${pageSize || 50}`
    api.authenticatedRequest('GET', `/queries/${queryId}/comments${query}`, null, success, fail)
  },
  createComment (queryId, data, success, fail) {
    api.authenticatedRequest('POST', `/queries/${queryId}/comments`, data, success, fail)
  },
  updateComment (queryId, commentId, data, success, fail) {
    api.authenticatedRequest('PUT', `/queries/${queryId}/comments/${commentId}`, data, success, fail)
  },
  deleteComment (queryId, commentId, success, fail) {
    api.authenticatedRequest('DELETE', `/queries/${queryId}/comments/${commentId}`, null, success, fail)
  }
}
